import * as React from 'react';
export const cursorSvg = React.forwardRef(function cursorSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#72716d',
      d: 'm16.116 15.999 10.02 5.755a.7.7 0 0 1-.261.26l-9.366 5.38a.79.79 0 0 1-.786 0l-9.366-5.38a.7.7 0 0 1-.261-.26z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#55544f',
      d: 'M16.116 4.499v11.5l-10.02 5.755A.7.7 0 0 1 6 21.4V10.6a.71.71 0 0 1 .357-.616l9.365-5.38a.8.8 0 0 1 .394-.104',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#43413c',
      d: 'M26.136 10.243a.7.7 0 0 0-.262-.26l-9.365-5.38a.8.8 0 0 0-.393-.104v11.5l10.02 5.755a.7.7 0 0 0 .096-.355v-10.8a.7.7 0 0 0-.096-.356',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#d6d5d2',
      d: 'M25.435 10.646a.33.33 0 0 1 0 .334l-9.096 15.673c-.06.106-.223.062-.223-.06V16.265a.46.46 0 0 0-.063-.23z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'm25.435 10.646-9.381 5.389a.46.46 0 0 0-.17-.17l-8.99-5.163c-.107-.061-.063-.223.06-.223h18.19c.13 0 .234.07.29.167',
    }),
  );
});
cursorSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cursor = {
  category: 'brand',
  colorable: false,
  name: 'cursor',
  svg: cursorSvg,
};
